import { AfterViewInit, Directive, Input, Renderer2 } from '@angular/core';
import { IonInput } from '@ionic/angular';

@Directive({
  selector: '[addListAttribute]'
})
export class AddListAttributeDirective implements AfterViewInit {
  @Input() listId: string;

  constructor(private el: IonInput, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.getInputElement(this.el);
  }

  getInputElement(elRef: IonInput): void {
    elRef.getInputElement().then((input: HTMLInputElement) => {
      this.renderer.setAttribute(input, 'list', this.listId);
    });
  }
}
